export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";

export function count(type,data = {}) {
    return {
        type,
        data: data
    }
}
